import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledTableTimes } from './styles/StyledTableTimes';


const getTimeWithZero = (data) => {
  if (data < 10) {
    return('0' + data);
  }
  return data;
}


class BtnTimes extends Component {
  render() {
    const { onClickRow, data,} = this.props;

    return (
      <StyledTableTimes>
        <table className="table-times">
          <tbody>
            <tr 
              key={data.id}
              className={data.count > 0 ? "table-times-row table-times-row-free" : "table-times-row table-times-row-full" }
              onClick={e => onClickRow(data.id, data.count, data.max_count)}
            >
              <td className="table-times-col-time">
                <div className="table-times-div-time">
                  {getTimeWithZero(new Date(data.time_from).getHours()) + ':' + getTimeWithZero(new Date(data.time_from).getMinutes())}
                </div>
              </td>
              <td className="table-times-td-capacity">
                {data.count + ' / ' + data.max_count}
              </td>
              <td className="table-times-td-arrow">
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </StyledTableTimes>
    );
  }
}


BtnTimes.propTypes = {
  data: PropTypes.object.isRequired,
  onClickRow: PropTypes.func.isRequired,
};

export default BtnTimes;



// WEBPACK FOOTER //
// ./src/components/IntervalsContent/BtnTimes.js